module.exports = __webpack_public_path__ + "uK9sO6mmf5L0OqWIh/RDC_RED_Logo_House.svg";